import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardFocusedInboxOption')(function discardFocusedInboxOption(state) {
    var optionState = state.optionState;
    optionState.isEnabled = null;
}));
//# sourceMappingURL=discardFocusedInboxOption.js.map